<template>
  <div>
    <Hero />
    <AboutUs />
    <Portfolio />
    <Contact />
  </div>
</template>

<script>
import Hero from './components/Hero'
import AboutUs from './components/AboutUs'
import Portfolio from './components/Portfolio'
import Contact from './components/Contact'

export default {
  name: 'app',
  components: {
    Hero,
    AboutUs,
    Portfolio,
    Contact
  }
}
</script>

<style>
  img {
    outline: none;
  }
  section.full-height {
    height: 100vh;
  }
html {
  scroll-behavior: smooth;
}
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
</style>
